import { resolveAeternaAssetPath } from "./assetBase";

const AUDIO_PREFS_KEY = "aeterna-invicta-audio";
const MUSIC_VOLUME = 0.7;
const SFX_VOLUME = 0.6;
const CROSSFADE_MS = 2500;
// New devices start at 25% of the max music/sound volume.
const DEFAULT_VOLUME_LEVEL = 0.25;

const AETERNA_ASSET_ROOT = resolveAeternaAssetPath("/assets/aeterna-invicta");

const MUSIC_PLAYLISTS = {
  menu: [
    {
      id: "ironPass",
      url: `${AETERNA_ASSET_ROOT}/music/menu/Beyond_the_Iron_Pass.mp3`,
    },
    {
      id: "archivistsGambit",
      url: `${AETERNA_ASSET_ROOT}/music/menu/The_Archivist_s_Gambit.mp3`,
    },
    {
      id: "archivistsDesk",
      url: `${AETERNA_ASSET_ROOT}/music/menu/The_Archivist_s_Desk.mp3`,
    },
    {
      id: "kingdomGate",
      url: `${AETERNA_ASSET_ROOT}/music/menu/Beyond_the_Kingdom_Gate.mp3`,
    },
    {
      id: "gambitInOpenField",
      url: `${AETERNA_ASSET_ROOT}/music/menu/A_Gambit_in_Open_Field.mp3`,
    },
    {
      id: "scrollsAndCopperBells",
      url: `${AETERNA_ASSET_ROOT}/music/menu/Scrolls_and_Copper_Bells.mp3`,
    },
    {
      id: "quietPlay",
      url: `${AETERNA_ASSET_ROOT}/music/menu/The_Quiet_Play.mp3`,
    },
    {
      id: "goldenDeckSleeps",
      url: `${AETERNA_ASSET_ROOT}/music/menu/Where_the_Golden_Deck_Sleeps.mp3`,
    },
    {
      id: "beneathTheTavernFloor",
      url: `${AETERNA_ASSET_ROOT}/music/menu/Beneath_the_Tavern_Floor.mp3`,
    },
    {
      id: "twelveCopperPieces",
      url: `${AETERNA_ASSET_ROOT}/music/menu/Twelve_Copper_Pieces.mp3`,
    },
    {
      id: "curiosAtTheCrossroads",
      url: `${AETERNA_ASSET_ROOT}/music/menu/Curios_at_the_Crossroads.mp3`,
    },
    {
      id: "silverForAncientLore",
      url: `${AETERNA_ASSET_ROOT}/music/menu/Silver_for_Ancient_Lore.mp3`,
    },
    {
      id: "copperAndCandlewick",
      url: `${AETERNA_ASSET_ROOT}/music/menu/Copper_and_Candlewick.mp3`,
    },
    {
      id: "insideTheMerchantsVault",
      url: `${AETERNA_ASSET_ROOT}/music/menu/Inside_the_Merchant_s_Vault.mp3`,
    },
    {
      id: "ledgerOfHiddenThings",
      url: `${AETERNA_ASSET_ROOT}/music/menu/Ledger_of_Hidden_Things.mp3`,
    },
    {
      id: "silverForSecrets",
      url: `${AETERNA_ASSET_ROOT}/music/menu/Silver_for_Secrets.mp3`,
    },
    {
      id: "tradeAtTwilight",
      url: `${AETERNA_ASSET_ROOT}/music/menu/Trade_at_Twilight.mp3`,
    },
  ],
  match: [
    {
      id: "mountains",
      url: `${AETERNA_ASSET_ROOT}/music/match/Where_the_Mountains_Sleep.mp3`,
    },
    {
      id: "siegeOfStone",
      url: `${AETERNA_ASSET_ROOT}/music/match/The_Siege_of_Stone.mp3`,
    },
    {
      id: "gambitOfTheOldKings",
      url: `${AETERNA_ASSET_ROOT}/music/match/Gambit_of_the_Old_Kings.mp3`,
    },
    {
      id: "generalsMap",
      url: `${AETERNA_ASSET_ROOT}/music/match/The_General_s_Map.mp3`,
    },
    {
      id: "ancientMapsEdge",
      url: `${AETERNA_ASSET_ROOT}/music/match/The_Ancient_Map_s_Edge.mp3`,
    },
    {
      id: "victoryAtTheCrossing",
      url: `${AETERNA_ASSET_ROOT}/music/match/Victory_at_the_Crossing.mp3`,
    },
    {
      id: "kingsLastTurn",
      url: `${AETERNA_ASSET_ROOT}/music/match/The_King_s_Last_Turn.mp3`,
    },
    {
      id: "beforeTheShieldWall",
      url: `${AETERNA_ASSET_ROOT}/music/match/Before_the_Shield_Wall.mp3`,
    },
  ],
};

const SFX_URLS = {
  drawCard: `${AETERNA_ASSET_ROOT}/soundEffects/draw_card.ogg`,
  receiveNewCards: `${AETERNA_ASSET_ROOT}/soundEffects/receive_new_cards.ogg`,
  gainResource: [
    `${AETERNA_ASSET_ROOT}/soundEffects/gain_resource_1.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/gain_resource_2.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/gain_resource_3.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/gain_resource_4.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/gain_resource_5.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/gain_resource_6.ogg`,
  ],
  physicalAttack: [
    `${AETERNA_ASSET_ROOT}/soundEffects/woosh1.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/woosh2.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/woosh3.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/woosh4.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/woosh5.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/woosh6.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/woosh7.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/woosh8.ogg`,
  ],
  magicAttack: [
    `${AETERNA_ASSET_ROOT}/soundEffects/zap1.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/zap2.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/zapThreeToneDown.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/zapThreeToneUp.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/zapTwoTone.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/zapTwoTone2.ogg`,
  ],
  uiSwitch: [
    `${AETERNA_ASSET_ROOT}/soundEffects/switch_005.ogg`,
  ],
  playEquipment: [
    `${AETERNA_ASSET_ROOT}/soundEffects/card-slide-1.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/card-slide-2.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/card-slide-3.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/card-slide-4.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/card-slide-5.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/card-slide-6.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/card-slide-7.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/card-slide-8.ogg`,
  ],
  slotAbility: [
    `${AETERNA_ASSET_ROOT}/soundEffects/stoneHit1.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/stoneHit2.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/stoneHit3.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/stoneHit4.ogg`,
    `${AETERNA_ASSET_ROOT}/soundEffects/stoneHit5.ogg`,
  ],
};

let musicEnabled = false;
let soundEnabled = false;
let musicLevel = DEFAULT_VOLUME_LEVEL;
let soundLevel = DEFAULT_VOLUME_LEVEL;
let musicDesired = false;
let musicContext = "menu";
let unlockBound = false;
let shuffleBags = { menu: [], match: [] };
let lastTrackIds = { menu: null, match: null };
let activeTrackId = null;
let currentAudio = null;
let fadingAudio = null;
let fadeRaf = null;
let watchTimer = null;
let crossfading = false;
let playbackToken = 0;
const musicElements = new Set();

function normalizeLevel(value) {
  const level = Number(value);
  if (!Number.isFinite(level)) return DEFAULT_VOLUME_LEVEL;
  return Math.max(0, Math.min(1, level));
}

function musicVolume() {
  return MUSIC_VOLUME * musicLevel;
}

function readStoredPrefs() {
  const defaults = {
    music: false,
    sound: false,
    musicVolume: DEFAULT_VOLUME_LEVEL,
    soundVolume: DEFAULT_VOLUME_LEVEL,
  };
  if (typeof window === "undefined") return defaults;
  try {
    const raw = window.localStorage.getItem(AUDIO_PREFS_KEY);
    if (!raw) return defaults;
    const parsed = JSON.parse(raw);
    return {
      music: parsed?.music === true,
      sound: parsed?.sound === true,
      // Prefs saved before volume sliders existed keep full volume.
      musicVolume: normalizeLevel(parsed?.musicVolume ?? 1),
      soundVolume: normalizeLevel(parsed?.soundVolume ?? 1),
    };
  } catch {
    return defaults;
  }
}

function writeStoredPrefs() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(
      AUDIO_PREFS_KEY,
      JSON.stringify({
        music: musicEnabled,
        sound: soundEnabled,
        musicVolume: musicLevel,
        soundVolume: soundLevel,
      }),
    );
  } catch {
    return;
  }
}

function normalizeContext(context) {
  return context === "match" ? "match" : "menu";
}

function playlistTracks(context) {
  return MUSIC_PLAYLISTS[normalizeContext(context)] || MUSIC_PLAYLISTS.menu;
}

function shuffleList(items) {
  const next = [...items];
  for (let i = next.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = next[i];
    next[i] = next[j];
    next[j] = temp;
  }
  return next;
}

function refillShuffleBag(context, preferId = null) {
  const key = normalizeContext(context);
  const ids = playlistTracks(key).map((track) => track.id);
  let next = shuffleList(ids);
  if (preferId && ids.includes(preferId)) {
    next = [preferId, ...next.filter((id) => id !== preferId)];
  } else if (next.length > 1 && next[0] === lastTrackIds[key]) {
    const swapWith = next.findIndex((id) => id !== lastTrackIds[key]);
    if (swapWith > 0) {
      const temp = next[0];
      next[0] = next[swapWith];
      next[swapWith] = temp;
    }
  }
  shuffleBags[key] = next;
}

function takeNextTrackId(context, preferId = null) {
  const key = normalizeContext(context);
  if (!shuffleBags[key].length) {
    refillShuffleBag(key, preferId);
  }
  if (preferId && !activeTrackId && shuffleBags[key].includes(preferId)) {
    shuffleBags[key] = [
      preferId,
      ...shuffleBags[key].filter((id) => id !== preferId),
    ];
  }
  const nextId = shuffleBags[key].shift();
  if (!shuffleBags[key].length) {
    refillShuffleBag(key);
  }
  return nextId;
}

function getTrackById(context, id) {
  const tracks = playlistTracks(context);
  return tracks.find((track) => track.id === id) || tracks[0];
}

function clearFade() {
  if (fadeRaf && typeof cancelAnimationFrame === "function") {
    cancelAnimationFrame(fadeRaf);
  }
  fadeRaf = null;
}

function clearWatch() {
  if (watchTimer && typeof window !== "undefined") {
    window.clearInterval(watchTimer);
  }
  watchTimer = null;
}

function stopAudioElement(audio) {
  if (!audio) return;
  musicElements.delete(audio);
  audio.onended = null;
  audio.ontimeupdate = null;
  try {
    audio.pause();
  } catch {
    return;
  }
  try {
    audio.currentTime = 0;
  } catch {
    return;
  }
}

function disposeFadingAudio() {
  if (!fadingAudio) return;
  stopAudioElement(fadingAudio);
  fadingAudio = null;
}

function stopStrayMusic() {
  musicElements.forEach((audio) => {
    if (audio !== currentAudio && audio !== fadingAudio) {
      stopAudioElement(audio);
    }
  });
}

function createTrackAudio(context, trackId) {
  const track = getTrackById(context, trackId);
  const audio = new Audio(track.url);
  audio.preload = "auto";
  audio.loop = false;
  audio.volume = 0;
  musicElements.add(audio);
  return audio;
}

function rampVolumes(fromAudio, toAudio, fromStart, toStart, toEnd, durationMs, onDone) {
  clearFade();
  const startedAt =
    typeof performance !== "undefined" ? performance.now() : Date.now();
  const tick = (now) => {
    const elapsed =
      (typeof performance !== "undefined" ? now : Date.now()) - startedAt;
    const t = Math.min(1, elapsed / Math.max(1, durationMs));
    if (fromAudio) {
      fromAudio.volume = Math.max(
        0,
        Math.min(musicVolume(), fromStart + (0 - fromStart) * t),
      );
    }
    if (toAudio) {
      toAudio.volume = Math.max(
        0,
        Math.min(musicVolume(), toStart + (toEnd - toStart) * t),
      );
    }
    if (t < 1) {
      fadeRaf = requestAnimationFrame(tick);
      return;
    }
    fadeRaf = null;
    if (onDone) onDone();
  };
  fadeRaf = requestAnimationFrame(tick);
}

function attachTrackWatch(audio) {
  clearWatch();
  if (!audio || typeof window === "undefined") return;
  watchTimer = window.setInterval(() => {
    if (!musicDesired || !musicEnabled || crossfading || !currentAudio) return;
    if (currentAudio !== audio) return;
    const duration = Number(audio.duration);
    const currentTime = Number(audio.currentTime);
    if (!Number.isFinite(duration) || duration <= 0) return;
    if (!Number.isFinite(currentTime)) return;
    const remainingMs = (duration - currentTime) * 1000;
    if (remainingMs <= CROSSFADE_MS) {
      beginCrossfade(takeNextTrackId(musicContext));
    }
  }, 250);
  audio.onended = () => {
    if (!musicDesired || !musicEnabled) return;
    if (crossfading) return;
    beginCrossfade(takeNextTrackId(musicContext));
  };
}

function beginCrossfade(nextTrackId) {
  if (!musicDesired || !musicEnabled || typeof Audio === "undefined") return;
  if (!nextTrackId) return;
  playbackToken += 1;
  const token = playbackToken;
  crossfading = true;
  clearFade();
  clearWatch();
  disposeFadingAudio();

  const outgoing = currentAudio;
  const previousId = activeTrackId;
  const context = musicContext;
  if (outgoing) {
    outgoing.onended = null;
  }
  const incoming = createTrackAudio(context, nextTrackId);
  fadingAudio = outgoing;
  currentAudio = incoming;
  lastTrackIds[context] = nextTrackId;
  activeTrackId = nextTrackId;
  stopStrayMusic();

  const playResult = incoming.play();
  const startFade = () => {
    if (token !== playbackToken) return;
    rampVolumes(
      outgoing,
      incoming,
      outgoing ? outgoing.volume : 0,
      0,
      musicVolume(),
      CROSSFADE_MS,
      () => {
        disposeFadingAudio();
        if (currentAudio) {
          currentAudio.volume = musicVolume();
        }
        crossfading = false;
        attachTrackWatch(currentAudio);
      },
    );
  };

  if (playResult && typeof playResult.then === "function") {
    playResult.then(startFade).catch(() => {
      if (token !== playbackToken) return;
      crossfading = false;
      if (outgoing) {
        stopAudioElement(incoming);
        currentAudio = outgoing;
        fadingAudio = null;
        activeTrackId = previousId;
        lastTrackIds[context] = previousId;
        attachTrackWatch(currentAudio);
      }
    });
  } else {
    startFade();
  }
}

function startCurrentTrack(trackId, { fadeIn = true } = {}) {
  if (!musicDesired || !musicEnabled || typeof Audio === "undefined") return;
  playbackToken += 1;
  const token = playbackToken;
  clearFade();
  clearWatch();
  disposeFadingAudio();
  stopAudioElement(currentAudio);
  const audio = createTrackAudio(musicContext, trackId);
  currentAudio = audio;
  lastTrackIds[musicContext] = trackId;
  activeTrackId = trackId;
  crossfading = false;
  stopStrayMusic();

  const playResult = audio.play();
  const afterPlay = () => {
    if (token !== playbackToken || currentAudio !== audio) return;
    if (fadeIn) {
      rampVolumes(
        null,
        audio,
        0,
        0,
        musicVolume(),
        CROSSFADE_MS,
        () => {
          audio.volume = musicVolume();
          attachTrackWatch(audio);
        },
      );
    } else {
      audio.volume = musicVolume();
      attachTrackWatch(audio);
    }
  };

  if (playResult && typeof playResult.then === "function") {
    playResult.then(afterPlay).catch(() => {});
  } else {
    afterPlay();
  }
}

function ensurePlaying(preferId = null) {
  if (!musicDesired || !musicEnabled) return;
  if (currentAudio && !currentAudio.paused) return;
  const nextId = takeNextTrackId(musicContext, preferId);
  startCurrentTrack(nextId, { fadeIn: true });
}

function switchContext(nextContext, preferId = null) {
  const context = normalizeContext(nextContext);
  musicDesired = true;
  if (!musicEnabled) {
    musicContext = context;
    activeTrackId = null;
    return;
  }

  if (context === musicContext && currentAudio && !currentAudio.paused) {
    return;
  }

  musicContext = context;
  activeTrackId = null;
  const nextId = takeNextTrackId(context, preferId);
  if (!nextId) return;

  if (currentAudio && !currentAudio.paused) {
    beginCrossfade(nextId);
    return;
  }
  startCurrentTrack(nextId, { fadeIn: true });
}

function bindUnlock() {
  if (typeof window === "undefined" || unlockBound) return;
  unlockBound = true;
  const resume = () => {
    ensurePlaying();
  };
  window.addEventListener("pointerdown", resume, { passive: true });
  window.addEventListener("keydown", resume);
}

function haltPlayback() {
  playbackToken += 1;
  crossfading = false;
  clearFade();
  clearWatch();
  disposeFadingAudio();
  stopAudioElement(currentAudio);
  currentAudio = null;
  activeTrackId = null;
  stopStrayMusic();
}

export function loadAudioPrefs() {
  const prefs = readStoredPrefs();
  musicEnabled = prefs.music;
  soundEnabled = prefs.sound;
  musicLevel = prefs.musicVolume;
  soundLevel = prefs.soundVolume;
  bindUnlock();
  return prefs;
}

export function syncAudioPrefsFromSettings(settings = {}) {
  musicEnabled = settings?.music === true;
  soundEnabled = settings?.sound === true;
  writeStoredPrefs();
  bindUnlock();
  if (!musicEnabled) {
    haltPlayback();
  } else if (musicDesired) {
    ensurePlaying();
  }
}

export function setMusicEnabled(enabled) {
  musicEnabled = enabled === true;
  writeStoredPrefs();
  if (!musicEnabled) {
    haltPlayback();
  } else if (musicDesired) {
    ensurePlaying();
  }
}

export function setSoundEnabled(enabled) {
  soundEnabled = enabled === true;
  writeStoredPrefs();
}

export function setMusicVolume(level) {
  musicLevel = normalizeLevel(level);
  writeStoredPrefs();
  if (currentAudio && !crossfading && !fadeRaf) {
    currentAudio.volume = musicVolume();
  }
}

export function setSoundVolume(level) {
  soundLevel = normalizeLevel(level);
  writeStoredPrefs();
}

export function getMusicVolume() {
  return musicLevel;
}

export function getSoundVolume() {
  return soundLevel;
}

export function isMusicEnabled() {
  return musicEnabled;
}

export function isSoundEnabled() {
  return soundEnabled;
}

export function getMusicContext() {
  return musicContext;
}

export function setMusicContext(context, preferId = null) {
  switchContext(context, preferId);
}

export function startMenuMusic(preferId = null) {
  switchContext("menu", preferId);
}

export function startMatchMusic(preferId = null) {
  switchContext("match", preferId);
}

export function stopMenuMusic() {
  musicDesired = false;
  haltPlayback();
}

export function skipToNextTrack() {
  if (!musicEnabled || !musicDesired) return;
  if (typeof Audio === "undefined") return;
  const nextId = takeNextTrackId(musicContext);
  if (!nextId) return;
  if (!currentAudio || currentAudio.paused) {
    startCurrentTrack(nextId, { fadeIn: true });
    return;
  }
  beginCrossfade(nextId);
}

export function playSplashMusic() {
  startMenuMusic();
}

export function stopSplashMusic() {
  stopMenuMusic();
}

function resolveSfxUrl(sound) {
  const entry = SFX_URLS[sound];
  if (!entry) return null;
  if (Array.isArray(entry)) {
    if (!entry.length) return null;
    return entry[Math.floor(Math.random() * entry.length)];
  }
  return entry;
}

export function playSfx(sound) {
  if (!soundEnabled || soundLevel <= 0 || typeof Audio === "undefined") return;
  const url = resolveSfxUrl(sound);
  if (!url) return;
  const audio = new Audio(url);
  audio.volume = SFX_VOLUME * soundLevel;
  const playResult = audio.play();
  if (playResult && typeof playResult.catch === "function") {
    playResult.catch(() => {});
  }
}

let lastHoveredCardEl = null;

export function playCardHoverSfx(cardEl) {
  if (!cardEl || cardEl === lastHoveredCardEl) return;
  lastHoveredCardEl = cardEl;
  playSfx("cardHover");
}

export function playMatchSfxList(sounds) {
  if (!Array.isArray(sounds) || !sounds.length) return;
  sounds.forEach((sound) => playSfx(sound));
}

loadAudioPrefs();
